import axios from 'axios';
import { useMutation } from 'react-query';

import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';

export type UserInviteRequest = {
  dealer_id: string;
  email: string;
  first_name: string;
  last_name: string;
};

const useInviteUser = () => {
  const mutation = useMutation((data: UserInviteRequest) => {
    return axios.post(`${getBaseApi()}/dealer/invite_user`, JSON.stringify(data), {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('user_token')}` },
    });
  });

  return {
    invite: mutation.mutate,
    ...mutation,
  };
};

export { useInviteUser };
